const vocabList = [
  {
    title: 'Saying Hello',
    lang: 'ja-JP',
    words: [
      {
        word: 'こんにちは',
        pronounce: 'Konnichiwa',
        translate: 'สวัสดี'
      },
      {
        word: 'お元気ですか？',
        pronounce: 'Ogenki desu ka?',
        translate: 'สบายดีไหม?'
      },
      {
        word: '元気',
        pronounce: 'Genki',
        translate: 'สบายดี'
      },
      {
        word: 'ありがとう',
        pronounce: 'Arigatou',
        translate: 'ขอบคุณ'
      }
    ]
  },
  {
    title: 'Ordering Ramen',
    lang: 'ja-JP',
    words: [
      {
        word: 'ラーメン',
        pronounce: 'Rāmen',
        translate: 'ราเม็ง'
      },
      {
        word: 'しょうゆラーメン',
        pronounce: 'Shouyu rāmen',
        translate: 'ราเม็งโชยุ'
      },
      {
        word: 'お願いします',
        pronounce: 'Onegai shimasu',
        translate: 'กรุณาด้วยค่ะ/ครับ'
      },
      {
        word: '少々お待ちください',
        pronounce: 'Shou shou omachi kudasai',
        translate: 'กรุณารอสักครู่'
      }
    ]
  },
  {
    title: 'At a Convenience Store',
    lang: 'ja-JP',
    words: [
      {
        word: 'おにぎり',
        pronounce: 'Onigiri',
        translate: 'ข้าวปั้น'
      },
      {
        word: 'いくらですか？',
        pronounce: 'Ikura desu ka?',
        translate: 'ราคาเท่าไหร่?'
      },
      {
        word: 'ください',
        pronounce: 'Kudasai',
        translate: 'กรุณา, ขอ...'
      },
      {
        word: 'お釣り',
        pronounce: 'Otsuri',
        translate: 'เงินทอน'
      },
      {
        word: 'ありがとうございました',
        pronounce: 'Arigatou gozaimashita',
        translate: 'ขอบคุณมากค่ะ/ครับ'
      }
    ]
  },
  {
    title: 'Parts of the body',
    lang: 'en-US',
    words: [
      {
        word: 'thumb',
        pronounce: 'thumb',
        translate: 'นิ้วหัวแม่มือ'
      },
      {
        word: 'cheeks',
        pronounce: 'cheeks',
        translate: 'แก้ม'
      },
      {
        word: 'wrist',
        pronounce: 'wrist',
        translate: 'ข้อมือ'
      },
      {
        word: 'thigh',
        pronounce: 'thigh',
        translate: 'ต้นขา'
      },
      {
        word: 'ankle',
        pronounce: 'ankle',
        translate: 'ข้อเท้า'
      }
    ]
  }
]

export {
  vocabList
}